import { createContext, useState } from "react";
import { deliveryState, dropDownData, deliveryPaneDisplay } from "../data";

export const DeliveryContextState = createContext({
  state: { deliveryState, dropDownData, deliveryPaneDisplay  },
  updateDelivery: () => {},
  updateDropDown: () => {},
  updateDeliveryPane: () => {},
});

export default function DeliveryContext({ children }) {
  const [state, setstate] = useState({ deliveryState, dropDownData, deliveryPaneDisplay });

  const updateDelivery = (data={}, key) => {
    return setstate({
      ...state,
      deliveryState: {
        ...state.deliveryState,
        [key]: { ...state.deliveryState[key], ...data },
      },
    });
  };

  const updateDropDown = (data=[], key) => {
    return setstate({
      ...state,
      dropDownData: {
        ...state.dropDownData,
        [key]: [...data ],
      },
    });
  };

  const updateDeliveryPane = (data=false, key) => {
    return setstate({
      ...state,
      deliveryPaneDisplay: {
        ...state.deliveryPaneDisplay,
        [key]: data,
      },
    });
  };

  return (
    <DeliveryContextState.Provider
      value={{ state, updateDelivery, updateDropDown, updateDeliveryPane }}
    >
      {children}
    </DeliveryContextState.Provider>
  );
}
